const { createApp, ref, component, watch, onMounted, reactive, onBeforeMount, onUnmounted, Transition } = Vue;

const familyPlanCsForm = createApp({
    name: "FamilyPlanCsForm",
    setup() {
        const formFlowOption = ref('');
        const formFlowOptions = ref([
            {
                label: "Swap my scent",
                value: "SWAP_MY_SCENT"
            },
            {
                label: "Change the delivery date",
                value: "CHANGE_DELIVERY_DATE"
            }
            ,
            {
                label: "Skip a delivery",
                value: "SKIP_DELIVERY"
            },
            {
                label: "Remove a member",
                value: "REMOVE_MEMBER"
            },
            {
                label: "Add a member",
                value: "ADD_MEMBER"
            },
            {
                label: "Cancel my plan",
                value: "CANCEL_PLAN"
            },
            {
                label: "Other (please specify)",
                value: "OTHER"
            }
        ]);

        function handleFlowChange(e) {
            //console.log(e.target.value, "select option");
            if (e.target.value) {
                formFlowOption.value = e.target.value;
            } else {
                formFlowOption.value = null;
            }
        }


        return {
            formFlowOption,
            formFlowOptions,
            handleFlowChange
        }
    },
    delimiters: ["${", "}"]
});

familyPlanCsForm.component('fp-cs-swap-form', {
    template: "#swapForm",
    setup(props) {
        const oilsDrp = ref(familyPlanDataObj.products);
        const currentScentSKU = ref(null);
        const swapScentSKU = ref(null);
        const firstName = ref('');
        const lastName = ref('');
        const isLoading = ref(false);

        onMounted(() =>{
            handleRecaptchaAvailability();
        })

        function handleCurrentScentSelect(p) {
            currentScentSKU.value = p;
        }

        function handleSwapScentSelect(p) {
            swapScentSKU.value = p;
        }

        async function handleFormSubmit(e) {
            e.preventDefault();
            const formData = new FormData(e.target);
            const jsonData = Object.fromEntries(formData.entries());
            const msgElement = document.querySelector('.family-plan__form--msg');
            msgElement.innerHTML = "";
            msgElement.style.display = "none";
            let plainTextFormData = "";
            const excludeKeys = ['description', 'g-recaptcha-response'];
            isLoading.value = true;
            if(jsonData['g-recaptcha-response']){
                for (const [key, value] of formData.entries()) {
                    if (!excludeKeys.includes(key)) {
                        plainTextFormData += `${key} - ${value}\n`;
                    }
                }
                document.getElementById('00NDn00000rA1v4').value = plainTextFormData;
                jsonData.description = plainTextFormData;
                const response = await fetch(familyPlanDataObj.web_to_sales_ingestor_url, {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(jsonData), 
                });
                const data = await response.json();
                if(data.status === 'success'){
                    if(jsonData.retURL){
                        window.location.replace(jsonData.retURL);
                    } 
                } else {
                    msgElement.innerHTML = data.message;
                    msgElement.style.display = "block";
                }
            } else {
                msgElement.innerHTML = "Please verify captcha";
                msgElement.style.display = "block";
                isLoading.value = false;
            }
        }

        return {
            oilsDrp,
            currentScentSKU,
            swapScentSKU,
            firstName,
            lastName,
            isLoading,
            handleCurrentScentSelect,
            handleSwapScentSelect,
            handleFormSubmit,
            handleRecaptchaAvailability
        }
    },
    delimiters: ["${", "}"]
});

familyPlanCsForm.component('fp-cs-change-delivery-form', {
    template: "#changeDeliveryForm",
    setup(props) {
        const firstName = ref('');
        const lastName = ref('');
        const currentDlvryDate = ref('');
        const isLoading = ref(false);

        onMounted(() =>{
            handleRecaptchaAvailability();
        })

        function getCurrentValidDate() {
            const currentDate = new Date();
            const fiveDaysLater = new Date(currentDate);
            fiveDaysLater.setDate(currentDate.getDate() + 5);
            const year = fiveDaysLater.getFullYear();
            const month = String(fiveDaysLater.getMonth() + 1).padStart(2, '0');
            const day = String(fiveDaysLater.getDate()).padStart(2, '0');
            const dateString = `${year}-${month}-${day}`;
            return dateString;
        }

        function handleCurrentDlvryDate(e) {
            currentDlvryDate.value = e.target.value;
        }

        async function handleFormSubmit(e) {
            e.preventDefault();
            const formData = new FormData(e.target);
            const jsonData = Object.fromEntries(formData.entries());
            const msgElement = document.querySelector('.family-plan__form--msg');
            msgElement.innerHTML = "";
            msgElement.style.display = "none";
            let plainTextFormData = "";
            const excludeKeys = ['description', 'g-recaptcha-response'];
            isLoading.value = true;
            if(jsonData['g-recaptcha-response']){
                for (const [key, value] of formData.entries()) {
                    if (!excludeKeys.includes(key)) {
                        plainTextFormData += `${key} - ${value}\n`;
                    }
                }
                document.getElementById('00NDn00000rA1v4').value = plainTextFormData;
                jsonData.description = plainTextFormData;
                const response = await fetch(familyPlanDataObj.web_to_sales_ingestor_url, {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(jsonData),
                });
                const data = await response.json();
                isLoading.value = false;
                if(data.status === 'success'){
                    if(jsonData.retURL){
                        window.location.replace(jsonData.retURL);
                    } 
                } else {
                    msgElement.innerHTML = data.message;
                    msgElement.style.display = "block";
                }
            } else {
                msgElement.innerHTML = "Please verify captcha";
                msgElement.style.display = "block";
                isLoading.value = false;
            }
        }

        return {
            firstName,
            lastName,
            currentDlvryDate,
            getCurrentValidDate,
            handleCurrentDlvryDate,
            handleFormSubmit,
            handleRecaptchaAvailability,
            isLoading
        }
    },
    delimiters: ["${", "}"]
});

familyPlanCsForm.component('fp-cs-skip-delivery-form', {
    template: "#skipDeliveryForm",
    setup(props) {
        const skipDeliveryOptions = ref([
            {
                label: "All Members",
                value: "ALL_MEMBERS"
            },
            {
                label: "Specific Member",
                value: "SPECIFIC_MEMBER"
            }
        ]);
        const skipDeliveryFor = ref('');
        const firstName = ref('');
        const lastName = ref('');
        const formRawData = ref('');
        const isLoading = ref(false);

        onMounted(() =>{
            handleRecaptchaAvailability();
        })


        function handleSkipDelivery(e) {
            skipDeliveryFor.value = e.target.value
        }

        async function handleFormSubmit(e) {
            e.preventDefault();
            const formData = new FormData(e.target);
            const jsonData = Object.fromEntries(formData.entries());
            const msgElement = document.querySelector('.family-plan__form--msg');
            msgElement.innerHTML = "";
            msgElement.style.display = "none";
            let plainTextFormData = "";
            const excludeKeys = ['description', 'g-recaptcha-response'];
            isLoading.value = true;
            if(jsonData['g-recaptcha-response']){
                for (const [key, value] of formData.entries()) {
                    if (!excludeKeys.includes(key)) {
                        plainTextFormData += `${key} - ${value}\n`;
                    }
                }
                document.getElementById('00NDn00000rA1v4').value = plainTextFormData;
                jsonData.description = plainTextFormData;
                const response = await fetch(familyPlanDataObj.web_to_sales_ingestor_url, {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(jsonData),
                });
                const data = await response.json();
                isLoading.value = false;
                if(data.status === 'success'){
                    if(jsonData.retURL){
                        window.location.replace(jsonData.retURL);
                    } 
                } else {
                    msgElement.innerHTML = data.message;
                    msgElement.style.display = "block";
                }
            } else {
                msgElement.innerHTML = "Please verify captcha";
                msgElement.style.display = "block";
                isLoading.value = false;
            }
        }

        return {
            skipDeliveryOptions,
            skipDeliveryFor,
            handleSkipDelivery,
            handleFormSubmit,
            handleRecaptchaAvailability,
            firstName,
            lastName,
            formRawData,
            isLoading
        }

    },
    delimiters: ["${", "}"]
});

familyPlanCsForm.component('fp-cs-add-member-form', {
    template: "#addMemberForm",
    setup(props) {
        const oilsDrp = ref(familyPlanDataObj.products);
        const diffuserVariants = ref(familyPlanDataObj.diffuser_variants);
        const oilSKU = ref(null);
        const diffuserSKU = ref(null);
        const firstName = ref('');
        const lastName = ref('');
        const additionalChargeConsent = ref(true);
        const isLoading = ref(false);

        onMounted(() =>{
            handleRecaptchaAvailability();
        })

        function handleOilSelect(p) {
            oilSKU.value = p;
        }

        function handleDiffuserSelect(p) {
            diffuserSKU.value = p;
        }

        async function handleFormSubmit(e) {
            e.preventDefault();
            const formData = new FormData(e.target);
            const jsonData = Object.fromEntries(formData.entries());
            const msgElement = document.querySelector('.family-plan__form--msg');
            msgElement.innerHTML = "";
            msgElement.style.display = "none";
            let plainTextFormData = "";
            const excludeKeys = ['description', 'g-recaptcha-response'];
            isLoading.value = true;
            if(jsonData['g-recaptcha-response']){
                for (const [key, value] of formData.entries()) {
                    if (!excludeKeys.includes(key)) {
                        plainTextFormData += `${key} - ${value}\n`;
                    }
                }
                document.getElementById('00NDn00000rA1v4').value = plainTextFormData;
                jsonData.description = plainTextFormData;
                const response = await fetch(familyPlanDataObj.web_to_sales_ingestor_url, {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(jsonData),
                });
                const data = await response.json();
                isLoading.value = false;
                if(data.status === 'success'){
                    if(jsonData.retURL){
                        window.location.replace(jsonData.retURL);
                    } 
                }else{
                    msgElement.innerHTML = data.message;
                    msgElement.style.display = "block";
                }
            } else {
                msgElement.innerHTML = "Please verify captcha";
                msgElement.style.display = "block";
                isLoading.value = false;
            }
        }

        function handleAdditionalChargeConsent(e){
            // console.log(e.target.checked,"content value");
            additionalChargeConsent.value = e.target.checked;
        }

        return {
            oilSKU,
            diffuserSKU,
            oilsDrp,
            diffuserVariants,
            firstName,
            lastName,
            additionalChargeConsent,
            handleOilSelect,
            handleDiffuserSelect,
            handleFormSubmit,
            formatMoneyy,
            handleAdditionalChargeConsent,
            handleRecaptchaAvailability,
            isLoading
        }
    },
    delimiters: ["${", "}"]
});

familyPlanCsForm.component('fp-cs-remove-member-form', {
    template: "#removeMemberForm",
    setup(props) {
        const firstName = ref('');
        const lastName = ref('');
        const formRawData = ref('');
        const isLoading = ref(false);

        onMounted(() =>{
            handleRecaptchaAvailability();
        })

        async function handleFormSubmit(e) {
            e.preventDefault();
            const formData = new FormData(e.target);
            const jsonData = Object.fromEntries(formData.entries());
            const msgElement = document.querySelector('.family-plan__form--msg');
            msgElement.innerHTML = "";
            msgElement.style.display = "none";
            let plainTextFormData = "";
            const excludeKeys = ['description', 'g-recaptcha-response'];
            isLoading.value = true;
            if(jsonData['g-recaptcha-response']){
                for (const [key, value] of formData.entries()) {
                    if (!excludeKeys.includes(key)) {
                        plainTextFormData += `${key} - ${value}\n`;
                    }
                }
                document.getElementById('00NDn00000rA1v4').value = plainTextFormData;
                jsonData.description = plainTextFormData;
                const response = await fetch(familyPlanDataObj.web_to_sales_ingestor_url, {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(jsonData),
                });
                const data = await response.json();
                isLoading.value = false;
                if(data.status === 'success'){
                    if(jsonData.retURL){
                        window.location.replace(jsonData.retURL);
                    } 
                } else {
                    msgElement.innerHTML = data.message;
                    msgElement.style.display = "block";
                }
            } else {
                msgElement.innerHTML = "Please verify captcha";
                msgElement.style.display = "block";
                isLoading.value = false;
            }
        }

        return {
            handleFormSubmit,
            handleRecaptchaAvailability,
            firstName,
            lastName,
            formRawData,
            isLoading
        }
    },
    delimiters: ["${", "}"]
});

familyPlanCsForm.component('fp-cs-cancel-form', {
    template: "#cancelPlanForm",
    setup(props) {
        const formCancelOption = ref(null);
        const formCancelOptions = ref([
            {
                label: "I have too many of this product",
                value: "I have too many of this product"
            },
            {
                label: "I stopped using this product",
                value: "I stopped using this product"
            }
            ,
            {
                label: "This product is too expensive",
                value: "This product is too expensive"
            },
            {
                label: "I don't like this product",
                value: "I don't like this product"
            },
            {
                label: "I wanted to switch to a different product/flavor",
                value: "I wanted to switch to a different product/flavor"
            },
            {
                label: "I had trouble managing my subscription",
                value: "I had trouble managing my subscription"
            },
            {
                label: "I'm having trouble with my diffuser",
                value: "I'm having trouble with my diffuser"
            },
            {
                label: "I no longer have any use for this product and I will not need it in the near future",
                value: "I no longer have any use for this product and I will not need it in the near future"
            },
            {
                label: "Other (please specify)",
                value: "other"
            }
        ]);
        const isValidTime = ref(false);
        const firstName = ref('');
        const lastName = ref('');
        const isLoading = ref(false);
        onMounted(() => {
            isValidTime.value = determineIfWithinWorkHours();
            handleRecaptchaAvailability();
        });
        
        /**
         * Determines if the current Eastern Time (ET) falls within standard work hours (9 AM to 6 PM).
         * This function accounts for both Eastern Standard Time (EST) and Eastern Daylight Time (EDT),
         * adjusting automatically for daylight saving changes.
         * 
         * @returns {boolean} true if within work hours, false otherwise.
         */
        function determineIfWithinWorkHours() {
            // Obtain the current time in Eastern Time, adjusting for daylight saving as needed.
            const easternTime = new Date().toLocaleString("en-US", { timeZone: "America/New_York" });
            const currentTimeInET = new Date(easternTime);
        
            // Extract the hour component from the current Eastern Time.
            const hourInET = currentTimeInET.getHours();
        
            // Define standard work hours in the 24-hour format.
            const workHourStart = 9;  // 9 AM
            const workHourEnd = 18;   // 6 PM
        
            // Check if the current hour in ET falls within the defined work hours.
            const withinWorkHours = hourInET >= workHourStart && hourInET < workHourEnd;
        
            // Optional: Log the result for debugging purposes.
            // console.log(`[Info] Current ET Hour: ${hourInET}, Within Work Hours: ${withinWorkHours}`);
        
            return withinWorkHours;
        }

        function handleCancelFlowChange(e) {
            // console.log(e.target.value, "select option");
            if (e.target.value) {
                formCancelOption.value = e.target.value;
            } else {
                formCancelOption.value = null;
            }
        }

        function submitHandler(e) {
            e.preventDefault();
            const form = document.getElementById("fplan-cancel__form");
            const formData = new FormData(form);
            const jsonData = {};
            formData.forEach(function (value, key) {
                jsonData[key] = value;
            });
            const parsedData = jsonData;
            const captchaToken = document.getElementById('recaptcha_token').value;
            isLoading.value = true;
            if(captchaToken){
                fetch('https://cscioy5r6wjwe2bakf4hufxzpa0ajgka.lambda-url.us-east-1.on.aws/', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        name: parsedData.firstname + ' ' + parsedData.lastname,
                        email: parsedData.email,
                        phone: parsedData.phone,
                        orderId: parsedData.order_number,
                        city: parsedData.city,
                        state: parsedData.state,
                        zip_code: parsedData.zip,
                        cancelationReason: parsedData.flow_option,
                        additional_info: parsedData.additional_info,
                        address: parsedData.address
                    }),
                })
                    .then(response => response.json())
                    .then(data => {
                        isLoading.value = false;
                        if(data.status){
                            form.reset();
                            window.location.href = '/pages/thank-you';
                        }else{
                            msgElement.innerHTML = "Invalid form submission";
                            msgElement.style.display = "block";
                        }
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    });
            }
        }

        return {
            formCancelOption,
            formCancelOptions,
            isValidTime,
            determineIfWithinWorkHours,
            handleCancelFlowChange,
            submitHandler,
            handleRecaptchaAvailability,
            firstName,
            lastName,
            isLoading
        }
    },
    delimiters: ["${", "}"]
});

familyPlanCsForm.component('fp-cs-other-reasons-form', {
    template: "#otherReasonForm",
    setup(props) {
        const firstName = ref('');
        const lastName = ref('');
        const isLoading = ref(false);

        onMounted(() =>{
            handleRecaptchaAvailability();
        })

        async function handleFormSubmit(e) {
            e.preventDefault();
            const formData = new FormData(e.target);
            const jsonData = Object.fromEntries(formData.entries());
            const msgElement = document.querySelector('.family-plan__form--msg');
            msgElement.innerHTML = "";
            msgElement.style.display = "none";
            let plainTextFormData = "";
            const excludeKeys = ['description', 'g-recaptcha-response'];
            isLoading.value = true;
            if(jsonData['g-recaptcha-response']){
                for (const [key, value] of formData.entries()) {
                    if (!excludeKeys.includes(key)) {
                        plainTextFormData += `${key} - ${value}\n`;
                    }
                }
                document.getElementById('00NDn00000rA1v4').value = plainTextFormData;
                jsonData.description = plainTextFormData;
                const response = await fetch(familyPlanDataObj.web_to_sales_ingestor_url, {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(jsonData),
                });
                const data = await response.json();
                isLoading.value = false;
                if(data.status === 'success'){
                    if(jsonData.retURL){
                        window.location.replace(jsonData.retURL);
                    }
                }else{
                    msgElement.innerHTML = data.message;
                    msgElement.style.display = "block";
                }
            } else {
                msgElement.innerHTML = "Please verify captcha";
                msgElement.style.display = "block";
                isLoading.value = false;
            }
        }
        return {
            firstName,
            lastName,
            handleFormSubmit,
            handleRecaptchaAvailability,
            isLoading
        }
    },
    delimiters: ["${", "}"]
});

familyPlanCsForm.component('fp-cs-product-select', {
    template: "#fsProductSelect",
    props: ['products', 'placeholder'],
    emits: ['on-product-selected'],
    setup(props, ctx) {
        const selectedProduct = ref(null);
        const isDropdownOpen = ref(false);

        function handleAddonSelect(option) {
            selectedProduct.value = option;
            ctx.emit('on-product-selected', option);
            isDropdownOpen.value = false;
        }

        function toggleDropdown() {
            isDropdownOpen.value = !isDropdownOpen.value;
        }

        return {
            selectedProduct,
            isDropdownOpen,
            imgUrl,
            handleAddonSelect,
            toggleDropdown
        }
    },
    delimiters: ["${", "}"]
});

familyPlanCsForm.mount("#familyPlanCsForm");

function imgUrl(url, size) {
    // remove any current image size then add the new image size
    return url
        .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, ".")
        .replace(/\.jpg|\.png|\.gif|\.jpeg/g, function (match) {
            return "_" + size + match;
        });
}

function formatMoneyy(cents, format = "") {
    if (typeof cents === "string") {
        cents = cents.replace(".", "");
    }
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = format || window.themeVariables.settings.moneyFormat;
    function defaultTo(value2, defaultValue) {
        return value2 == null || value2 !== value2 ? defaultValue : value2;
    }
    function formatWithDelimiterss(number, precision, thousands, decimal) {
        precision = defaultTo(precision, 2);
        thousands = defaultTo(thousands, ",");
        decimal = defaultTo(decimal, ".");
        if (isNaN(number) || number == null) {
            return 0;
        }
        number = roundNumber(number / 100, false, precision);
        let parts = number.split("."),
            dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
            centsAmount = parts[1] ? decimal + parts[1] : "";
        return dollarsAmount + centsAmount;
    }
    let value = "";
    switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
            value = formatWithDelimiterss(cents, 2);
            break;
        case "amount_no_decimals":
            value = formatWithDelimiterss(cents, 0);
            break;
        case "amount_with_space_separator":
            value = formatWithDelimiterss(cents, 2, " ", ".");
            break;
        case "amount_with_comma_separator":
            value = formatWithDelimiterss(cents, 2, ".", ",");
            break;
        case "amount_with_apostrophe_separator":
            value = formatWithDelimiterss(cents, 2, "'", ".");
            break;
        case "amount_no_decimals_with_comma_separator":
            value = formatWithDelimiterss(cents, 0, ".", ",");
            break;
        case "amount_no_decimals_with_space_separator":
            value = formatWithDelimiterss(cents, 0, " ");
            break;
        case "amount_no_decimals_with_apostrophe_separator":
            value = formatWithDelimiterss(cents, 0, "'");
            break;
    }
    if (formatString.indexOf("with_comma_separator") !== -1) {
        return formatString.replace(placeholderRegex, value);
    } else {
        return formatString.replace(placeholderRegex, value);
    }
}

function roundNumber(num, savings, precision = 2) {
    if (isNaN(num)) {
        return;
    }

    let nummm = num.toFixed(3).split(".")[1].slice(2);
    if (nummm > 4 && !savings) {
        let number = Math.ceil((num + Number.EPSILON) * 100) / 100;
        return number.toFixed(precision);
    } else if (nummm < 6 && savings) {
        let number = Math.floor((num + Number.EPSILON) * 100) / 100;
        return number.toFixed(precision);
    } else {
        let number = Math.round((num + Number.EPSILON) * 100) / 100;
        return number.toFixed(precision);
    }
}

function handleRecaptchaAvailability() {
    if (typeof grecaptcha !== "undefined" && typeof grecaptcha.enterprise.render === "function") {
        grecaptcha.enterprise.render(`recaptcha_fp_cs`, {
            sitekey: "6LfeJyUqAAAAAPkVgk_VuyW6b52woueyz4seDRCt"
        });
    }
};